import type { OAuthButtonsTranslations } from "./pl";

export const en: OAuthButtonsTranslations = {
  dividerOr: "or",
  facebookButton: "Sign in with Facebook",
  signingIn: "Signing in…",
  facebookCancelled: "Facebook sign-in was cancelled.",
  facebookFailed: "Facebook sign-in failed.",
  googleFailed: "Google sign-in failed.",
};
